import { Injectable } from "@angular/core";
import { KeyedCollection } from "../infrastructure/keyed-collection";
import { SearchFilter } from "../infrastructure/iFilter-component";
import { FormGroup } from "@angular/forms";
import { IFilterComplete } from "../filter-complete/filter-complete";
import { UserFilterService } from "./user-filter/user-filter.service";
import { AuthService } from "./auth.service";
import { UserFilter } from "../components/user-filter/user-filter";

@Injectable()
export class FilterRecordService {
  private componentSearchFilter: KeyedCollection<SearchFilter[]>;

  constructor(
    private userFilterService: UserFilterService,
    private authService: AuthService,
  ) {
    this.componentSearchFilter = new KeyedCollection<SearchFilter[]>();
  }

  // ================================
  // CONVERTIR FORM A SEARCHFILTER
  // ================================
  convertToSearchFilters(
    form: FormGroup,
    requieredTags: string[] = [],
  ): SearchFilter[] {
    const ret: SearchFilter[] = [];

    Object.keys(form.controls).forEach((key) => {
      const control = form.get(key);

      if (
        control &&
        control.valid &&
        control.value != null &&
        control.value !== ""
      ) {
        const isRequired = requieredTags.indexOf(key) > -1;
        const searchFilter = new SearchFilter(key, control.value, isRequired);

        ret.push(searchFilter);
      }
    });

    return ret.filter((r) => r.valueView);
  }

  async getFiltersFromServer(componentName: string): Promise<SearchFilter[]> {
    const userFilter = await this.userFilterService.getByUserAndComponent(
      this.authService.getUserId(),
      componentName,
    );

    if (!userFilter) return;

    const rawFilters = JSON.parse(userFilter.Filter);

    const filters: SearchFilter[] = rawFilters.map(
      (f: any) =>
        new SearchFilter(
          f.key,
          this.reviveValue(f.value), // importante para fechas
          f.isRequired,
        ),
    );

    return filters;
  }

  async loadFiltersFromServer(componentName: string, form: FormGroup): Promise<boolean> {
    const filters = await this.getFiltersFromServer(componentName);

    if (this.componentSearchFilter.ContainsKey(componentName)) {
      this.componentSearchFilter.Remove(componentName);
    }

    this.componentSearchFilter.Add(componentName, filters);

    this.setFilters(componentName, form);

    return true;
  }

  async saveFiltersOnServer(componentName: string, form: FormGroup) {
    const filters: SearchFilter[] = this.convertToSearchFilters(form);

    const userFilter: UserFilter = {
      UserId: this.authService.getUserId(),
      Component: componentName,
      Filter: JSON.stringify(filters),
    };

    await this.userFilterService.save(userFilter);

    if (this.componentSearchFilter.ContainsKey(componentName)) {
      this.componentSearchFilter.Remove(componentName);
    }

    this.componentSearchFilter.Add(componentName, filters);
    this.setFilters(componentName, form);
  }

  saveFilters(componentName: string, form: FormGroup): void {
    const filters: SearchFilter[] = this.convertToSearchFilters(form);

    if (this.componentSearchFilter.ContainsKey(componentName)) {
      this.componentSearchFilter.Remove(componentName);
    }

    this.componentSearchFilter.Add(componentName, filters);
  }

  setFilters(componentName: string, form: FormGroup): boolean {
    if (!this.componentSearchFilter.ContainsKey(componentName)) {
      return false;
    }

    const filters = this.componentSearchFilter.Item(componentName);

    filters.forEach((filter) => {
      const control = form.get(filter.key);
      if (control) {
        control.setValue(filter.value);
      }
    });

    return true;
  }

  getFilters(componentName: string): SearchFilter[] {
    if (this.componentSearchFilter.ContainsKey(componentName)) {
      return this.componentSearchFilter.Item(componentName);
    }

    return [];
  }

  existsFilters(componentName: string): boolean {
    return this.componentSearchFilter.ContainsKey(componentName);
  }

  getFilterFromList<T extends IFilterComplete>(
    componentName: string,
    key: string,
    items: T[],
  ): T[] {
    const response: T[] = [];
    const filters = this.getFilters(componentName);

    if (!filters) return response;

    const searchFilter = filters.find((f) => f.key === key);
    if (!searchFilter) return response;

    const recordFilters = searchFilter.value as T[];
    if (!recordFilters) return response;

    recordFilters.forEach((item) => {
      const index = items.findIndex((e) => e.Id === item.Id);
      if (index > -1) {
        response.push(items[index]);
      }
    });

    return response;
  }

  private reviveValue(value: any): any {
    if (!value) return value;

    // detectar ISO Date string
    if (typeof value === "string") {
      const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/;

      if (isoDateRegex.test(value)) {
        return new Date(value);
      }
    }

    return value;
  }
}
